// pag12.js (pagina principală)
import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';

import IntrariTab from './tabs/IntrariTab';
import VanzariTab from './tabs/VanzariTab';
import RestituitTab from './tabs/RestituitTab';
import ServiciiTab from './tabs/ServiciiTab';
import ModificariTab from './tabs/ModificariTab';
import StocuriTab from './tabs/StocuriTab';
import CnlaVdTab from './tabs/CnlaVdTab';

function Pag12(props) {
  const [value, setValue] = useState('1');
  const [category, setCategory] = useState('');
  const handleChange = (event, newValue) => setValue(newValue);

  return (
    <Box>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="activity tabs">
            <Tab label="Intrări" value="1" />
            <Tab label="Vânzări" value="2" />
            <Tab label="Restituit" value="3" />
            <Tab label="Servicii" value="4" />
            <Tab label="Modificari" value="5" />
            <Tab label="Stocuri" value="6" />
            <Tab label="CNlaVD" value="7" />
          </Tabs>
        </Box>

        <TabPanel value="1" sx={{ padding: 0 }}>
          <IntrariTab
            intrariDataFiltered={props.intrariDataFiltered || []}
            intrariStartDate={props.intrariStartDate}
            intrariEndDate={props.intrariEndDate}
            setIntrariStartDate={props.setIntrariStartDate}
            setIntrariEndDate={props.setIntrariEndDate}
            exportToExcel={props.exportToExcel}
            exportToPDF={props.exportToPDF}
            handleExportZip={props.handleExportZip}
            handleRefreshTasks={props.handleRefreshTasks}
            totalPretIntrare={props.totalPretIntrare}
            numarTotalIntrari={props.numarTotalIntrari}
            isSyncing={props.isSyncing}
            exportDialogOpen={props.exportDialogOpen}
            exportDialogText={props.exportDialogText}
            exportLogMessages={props.exportLogMessages || []}
            setExportDialogOpen={props.setExportDialogOpen}
            isLoadingIntrari={props.isLoadingIntrari}
            handleRecChangeForIntrari={props.handleRecChangeForIntrari}
          />
        </TabPanel>
        <TabPanel value="2" sx={{ padding: 0 }}>
          <VanzariTab />
        </TabPanel>
        <TabPanel value="3" sx={{ padding: 0 }}>
          <RestituitTab {...props} filteredData={props.filteredData || []} />
        </TabPanel>
        <TabPanel value="4" sx={{ padding: 0 }}>
          <ServiciiTab {...props} dataToDisplay={props.dataToDisplay || []} />
        </TabPanel>
        <TabPanel value="5" sx={{ padding: 0 }}>
          <ModificariTab {...props} modificariData={props.modificariData || []} />
        </TabPanel>
        <TabPanel value="6" sx={{ padding: 0 }}>
          <StocuriTab
            {...props}
            category={category}
            setCategory={setCategory}
            paginatedStockData={props.paginatedStockData || []}
            stockData={props.stockData || []}
          />
        </TabPanel>
        <TabPanel value="7" sx={{ padding: 0 }}>
          <CnlaVdTab {...props} cnlaVdDataFiltered={props.cnlaVdDataFiltered || []} />
        </TabPanel>
      </TabContext>
    </Box>
  );
}

export default Pag12;
